import { initializeApp } from "firebase/app";
import { getMessaging, onMessage } from "firebase/messaging";
import { toast } from "react-toastify";
import firebaseConfig from "./firebaseConfig";

const app = initializeApp(firebaseConfig)


// Initialize Firebase Cloud Messaging and get a reference to the service
export const messaging = getMessaging(app);
console.log('messaging', messaging);

toast.success('🦄 Xin chào, Quản trị', {
  position: "top-right",
  autoClose: true,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
});

onMessage(messaging, (payload) => {
  console.log('Message received. ', payload);

  const title = payload.notification.title;

  document.querySelector('#' + title) && document.querySelector('#' + title).click()

  toast.warn(payload.notification.body, {
    position: "bottom-right",
    autoClose: false,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
  // ...
});

export default app;
